<template>
    <div class="app">
        <AppHeader fixed style="background-color: #428bca">
            <SidebarToggler class="d-lg-none" display="md" mobile/>
            <b-link class="navbar-brand" to="#" style="color: #fff; font-weight: bold; width: 155px;">
                BIS-Office
            </b-link>
            <SidebarToggler class="d-md-down-none" display="lg"/>
            <b-navbar-nav class="ml-auto">
                <b-nav-item class="d-md-down-none" @click="refresh">
                    <i class="icon-refresh" style="color: #fff;"></i>
                </b-nav-item>
                <DefaultHeaderDropdownAccnt @change-password="changePassword" @switch-user="switchUser"
                                            :username="username"/>

                <ChangeModuleDropdown :modules="modules"
                                      @admin="gotoAdministration"
                                      @baumkontrolle="gotoBaumKontrolle"
                                      @nutzerverwaltung="gotoNutzerverwaltung"
                                      @mobileSettings="gotoMobileSettings"
                                      @auftragsbuch="gotoAuftragsbuch"
                />
                <ChangeSuiteDropdown
                        v-if="showLogOn"
                        :suites="suites"
                        :current="mySuite"
                        @log-on="logon"/>
                <b-nav-item class="d-md-down-none" @click="logout">
                    <i class="icon-logout" style="color: #fff;"></i>
                </b-nav-item>
            </b-navbar-nav>
        </AppHeader>
        <div class="app-body">
            <AppSidebar fixed>
                <SidebarHeader/>
                <SidebarForm/>
                <SidebarNav :navItems="nav" v-if="renderComponent"></SidebarNav>
                <SidebarFooter/>
                <SidebarMinimizer/>
            </AppSidebar>
            <main class="main" style="background-color: #fff">
                <div class="container-fluid" style="padding: 0px; height: 100%">
                    <router-view v-if="show" :key="$route.path"></router-view>
                </div>
            </main>
        </div>
        <b-modal title="Passwort ändern" v-model="myModal" @cancel="changePasswordCancel" @ok.prevent="changePasswordOk"
                 ok-title="Ändern"
                 cancel-title="Abbrechen"
        >
            <b-container fluid>
                <b-row>
                    <b-col md="4">
                        <p style="margin-bottom: 0; margin-top: 0.5rem;">Altes Passwort</p></b-col>
                    <b-col>
                        <b-form-input v-model="oldPwd"
                                      class="form-control text-black" type="password"
                                      v-on:focus="pwdError=''"
                        ></b-form-input>
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                    <b-col md="4">
                        <p style="margin-bottom: 0; margin-top: 0.5rem;">Neues Passwort</p></b-col>
                    <b-col>
                        <b-form-input v-model="newPwd1"
                                      class="form-control text-black" type="password"
                                      v-on:focus="pwdError=''"
                        ></b-form-input>
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                    <b-col md="4">
                        <p style="margin-bottom: 0; margin-top: 0.5rem;">Passwort wiederholen</p></b-col>
                    <b-col>
                        <b-form-input v-model="newPwd2"
                                      class="form-control text-black" type="password"
                                      v-on:focus="pwdError=''"
                        ></b-form-input>
                    </b-col>
                </b-row>
                <b-row v-if="pwdError !== ''"><p style="margin-top: 2rem; margin-left: 1rem; color: red;">
                    {{pwdError}}</p></b-row>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
    import nav_admin from '@/_nav_admin'
    import {
        Header as AppHeader,
        Aside as AppAside,
        AsideToggler,
        Footer as TheFooter,
        Breadcrumb
    } from '@coreui/vue'
    import {
        SidebarToggler,
        Sidebar as AppSidebar,
        SidebarFooter,
        SidebarForm,
        SidebarHeader,
        SidebarMinimizer,
        SidebarNav,
    } from '../custom_core_ui'
    import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
    import DownloadWindowsDropdown from './DownloadWindowsDropdown'
    import ChangeModuleDropdown from './ChangeModuleDropdown'
    import ChangeSuiteDropdown from './ChangeSuiteDropdown'
    import {
      Cookie_Path, HUB_SERVER,
      Redirect_500,
      Redirect_Login,
      Server_LOGOUT,
      Server_URL_BASE, Server_URL_ZK, URL_AUFTRAGSBUCH,
      URL_BAUMKONTROLLE, URL_MOBILE_SETTINGS,
      URL_NUTZERVERWALTUNG
    } from "../shared/utils";
    import {decryptTable, encryptAESWithPw, getKey, getValue} from "../shared/crypto";
    import {CrossStorageClient} from "cross-storage"
    import {cookieDelete, storageDelete, storageSet} from "../shared/electron";


    export default {
        name: 'DefaultContainer',
        components: {
            ChangeModuleDropdown,
            AsideToggler,
            AppHeader,
            AppSidebar,
            AppAside,
            TheFooter,
            Breadcrumb,
            DefaultHeaderDropdownAccnt,
            SidebarForm,
            SidebarFooter,
            SidebarToggler,
            SidebarHeader,
            SidebarNav,
            SidebarMinimizer,
            DownloadWindowsDropdown,
            ChangeSuiteDropdown
        },

        created: function () {
            if (!this.$cookies.isKey("ps")) {
                window.location = Redirect_Login;
                return;
            }
            if (this.$cookies.isKey("ps_username")) {
                this.username = this.$cookies.get("ps_username");
            }
            this.setCookie("ps_module", "13", -1, null, Cookie_Path, true);
            this.$http.get(
                Server_URL_ZK + '/zk/settings'
            ).then(this.responseOkGet, this.responseError)
            if (this.isElectron()) {
                let url = window.location.href;
                window.top.postMessage({typ: 'url', url: url}, "*");
            }
        },
        data() {
            return {
                nav: [],
                renderComponent: true,
                loader: undefined,

                myModal: false,

                oldPwd: "",
                newPwd1: "",
                newPwd2: "",

                pwdError: "",
                errorEmpty: "Die Passwörter dürfen nicht leer sein.",
                errorUneven: "Die neuen Passwörter stimmen nicht überein.",
                errorInvalid: "Ihr eingegebenes Passwort ist falsch.",
                username: "Einstellungen",
                permission_personal: 2,
                permission_rb: 2,
                modules: [],
                show: false,
                encryption: [],
                checksum: 0,
                storage: null,
                isEncrypted: true,
                showLogOn: false,
                suites: [],
                mySuite: {}
            }
        },
        methods: {
            showLoader() {
                this.loader = this.$loading.show();
            },
            hideLoader() {
                if (this.loader !== undefined) {
                    this.loader.hide();
                    this.loader = undefined;
                }
            },
            responseOkLogout(response) {
                this.hideLoader();
                sessionStorage.clear();
                window.location = Redirect_Login;
            },
            responseOkGet(response) {
                if (response.status === 200) {
                    console.log(response);
                    let nav = [];
                    this.modules = response.body.modules;

                  for (let i = 0; i < this.modules.length; i++) {
                    if (this.modules[i] === 13) {
                      // personal
                      nav.push(nav_admin.items.header);
                      nav.push(nav_admin.items.booking);
                      nav.push(nav_admin.items.basis_data);
                    } else if (this.modules[i] === 14) {
                      let persFound = false;
                      for (let j = 0; j < this.modules.length; j++) {
                        if (this.modules[j] === 13) {
                          persFound = true;
                        }
                      }
                      if (!persFound) {
                        nav.push(nav_admin.items.header_rb);
                      }
                      if (response.permission_rb === 9) {
                        console.log("here")
                        nav.push(nav_admin.items.rb_admin);
                      } else {
                        //nav.push(nav_admin.items.rb);
                        nav.push(nav_admin.items.rb_admin);
                      }
                    }
                  }

                  // todo remove in production
                  nav.push(nav_admin.items.basis_data);
                  nav.push(nav_admin.items.zk);

                    this.permission_rb = response.body.permission_rb;
                    this.permission_personal = response.body.permission_personal;
                    this.modules = response.body.modules;
                    this.mySuite = response.body.my_suite;
                    this.suites = response.body.suite_links;
                    if (this.isElectron() && this.suites !== null
                        && this.suites !== undefined && this.suites.length > 0) {
                        this.showLogOn = true;
                    }
                    this.nav = nav;

                    this.encryption = response.body.encryption;
                    this.checksum = response.body.checksum;
                    if (!this.hasModule(13) && !this.hasModule(14)) {
                        // unauthorized
                        this.hideLoader();
                        window.location = Redirect_500;
                    }

                    if (this.isEncrypted) {
                        this.loadSession()
                    } else {
                        this.hideLoader();
                        this.show = true;
                    }
                } else {
                    this.hideLoader();
                    window.location = Redirect_500;
                }
            },
            responseError(response) {
                this.hideLoader();
                if (response.status === 401) {
                    window.location = Redirect_Login;
                } else {
                    window.location = Redirect_500;
                }
            },
            logout() {
                if (this.isElectron()) {
                    window.top.postMessage("close", "*");
                } else {
                    this.switchUser();
                }
            },
            switchUser() {
                this.showLoader();
                this.$cookies.remove("ps_pw", null, Cookie_Path);
                cookieDelete("ps_pw");
                this.clearLinks().then(res => this.$http.post(
                    Server_LOGOUT + '/stammdaten/logout'
                ).then(this.responseOkLogout, this.responseError))
            },
            changePassword() {
                this.myModal = !this.myModal;
            },
            changePasswordOk() {
                if (this.oldPwd === '' || this.newPwd1 === '' || this.newPwd2 === '') {
                    this.pwdError = this.errorEmpty;
                    return
                } else if (this.newPwd2 !== this.newPwd1) {
                    this.pwdError = this.errorUneven;
                    return;
                }
                this.showLoader();
                if (this.isEncrypted) {
                    if (this.storage === null) {
                        this.storage = new CrossStorageClient(HUB_SERVER);
                    }
                    this.storage.onConnect().then(() => {
                        getKey(this.$cookies.get("ps_customer_number") + this.$cookies.get("ps_username") + "cert").then(res => {
                            this.storage.get(res)
                                .then(res => {
                                    getValue(res).then(res => {
                                        let cert = JSON.parse(res);
                                        encryptAESWithPw(this.newPwd1, cert.priv).then(res => {
                                            this.$http.post(
                                                Server_URL_BASE + '/stammdaten/suite/user/change_password',
                                                {pwd: this.oldPwd, new_pwd: this.newPwd1, restore: res}
                                            ).then(this.responsePwdOk, this.responsePwdError)
                                        })
                                    });
                                })
                        })
                    }).catch(err => console.log(err))
                } else {
                    this.$http.post(
                        Server_URL_BASE + '/stammdaten/suite/user/change_password',
                        {pwd: this.oldPwd, new_pwd: this.newPwd1}
                    ).then(this.responsePwdOk, this.responsePwdError)
                }
            },
            changePasswordCancel() {
                this.oldPwd = "";
                this.newPwd1 = "";
                this.newPwd2 = "";
                this.pwdError = "";
            },
            responsePwdOk(response) {
                this.hideLoader();
                this.myModal = false;
                if (this.isElectron()) {
                    this.setCookie("ps_pw", this.newPwd1, -1, null, Cookie_Path, true);
                    this.saveUserToLocalStorage(true, this.mySuite.value_2).then(res => console.log(res)).catch(res => console.log(res));
                }
            },
            responsePwdError(response) {
                this.hideLoader();
                this.pwdError = this.errorInvalid;
            },
            refresh() {
                location.reload();
            },
            isElectron() {
                let userAgent = navigator.userAgent.toLowerCase();
                return userAgent.indexOf(' electron/') > -1;
            },
            gotoBaumKontrolle() {
                window.location = URL_BAUMKONTROLLE;
            },
            gotoNutzerverwaltung() {
                window.location = URL_NUTZERVERWALTUNG;
            },
            gotoAdministration() {

            },
            gotoMobileSettings() {
                window.location = URL_MOBILE_SETTINGS;
            },
          gotoAuftragsbuch() {
            window.location = URL_AUFTRAGSBUCH;
          },
            logon(event) {
                this.showLoader();
                this.saveUserToLocalStorage(false, this.mySuite.value_2).then(res => {
                    sessionStorage.clear();
                    this.hideLoader();
                    window.location = Redirect_Login + "?switch_suite=" + event + "&user=" + this.$cookies.get("ps_username");
                }).catch(res => {
                    console.log(res);
                    this.hideLoader();
                });
            },
            hasModule(module) {
                for (let i = 0; i < this.modules.length; i++) {
                    if (this.modules[i] === module) {
                        return true;
                    }
                }
                return false
            },
            loadSession() {
                let check = sessionStorage.getItem("_checksum_");
                if (this.checksum !== 0 && check !== null && this.checksum.toString() === check) {
                    this.hideLoader();
                    this.show = true;
                    return
                }
                this.storage = new CrossStorageClient(HUB_SERVER);
                this.storage.onConnect().then(() => {
                    getKey(this.$cookies.get("ps_customer_number") + this.$cookies.get("ps_username") + "aes").then(res => {
                        this.storage.get(res)
                            .then(res => {
                                getValue(res).then(res => {
                                    sessionStorage.clear();
                                    sessionStorage.setItem("aes", res);
                                    decryptTable(res, this.encryption).then(res => {
                                        this.encryption = res;
                                        for (let i = 0; i < this.encryption.length; i++) {
                                            sessionStorage.setItem(this.encryption[i].id, JSON.stringify(this.encryption[i]));
                                        }
                                        sessionStorage.setItem("_checksum_", this.checksum.toString());
                                        this.hideLoader();
                                        this.show = true;
                                    })
                                })
                            })
                    })
                }).catch(err => console.log(err))
            },
            receiveMessage(e) {
                if (e.data !== undefined ) {
                    //console.log(e.data);
                }
            },
            async clearLinks() {
                if (!this.isElectron()) {
                    return
                }
                if (this.storage === null) {
                    this.storage = new CrossStorageClient(HUB_SERVER);
                }
                await this.storage.onConnect();
                let res = await this.storage.get("links");
                if (res === null || res === "") {
                    return
                }
                let links = JSON.parse(res);
                for (let i = 0; i < links.length; i++) {
                    storageDelete(links[i].customer_number);
                    await this.storage.del(links[i].customer_number);
                }
                storageDelete("links");
                return this.storage.del("links");

            },
            async saveUserToLocalStorage(doCheck, suiteName) {
                if (!this.isElectron()) {
                    return
                }
                if (this.storage === null) {
                    this.storage = new CrossStorageClient(HUB_SERVER);
                }
                await this.storage.onConnect();

                let res = await this.storage.get(this.$cookies.get("ps_customer_number"))
                if ((res === null || res === "") && doCheck) {
                    return;
                } else {

                    let links = [];
                    links.push({
                        customer_number: this.$cookies.get("ps_customer_number"),
                        customer_name: suiteName,
                    });

                    for (let i = 0; i < this.suites.length; i++) {
                        links.push({
                            customer_number: this.suites[i].id,
                            customer_name: this.suites[i].value_2,
                        });
                    }
                    storageSet("links", JSON.stringify(links));
                    await this.storage.set("links", JSON.stringify(links));
                    let user = {
                        user_id: this.$cookies.get("ps_user_id"),
                        username: this.$cookies.get("ps_username"),
                        pw: this.$cookies.get("ps_pw"),
                        suite_id: this.$cookies.get("ps_customer_number"),
                        suite_name: suiteName,
                    };
                    storageSet(this.$cookies.get("ps_customer_number"), JSON.stringify(user));
                    return this.storage.set(this.$cookies.get("ps_customer_number"), JSON.stringify(user))
                }

            },
            setCookie(keyName, value, expireTimes, path, domain, secure) {
                this.$cookies.set(keyName, value, expireTimes, path, domain, secure);
                if (this.isElectron()) {
                    window.top.postMessage(
                        {
                            typ: 'cookie',
                            keyName: keyName,
                            value: value,
                            expireTimes: expireTimes,
                            path: path,
                            domain: domain,
                            secure: secure
                        }, "*");
                }
            },
        },
        mounted() {
            window.addEventListener('message', this.receiveMessage)
        },
        beforeDestroy() {
            window.removeEventListener('message', this.receiveMessage)
        },
        computed: {
            name() {
                return this.$route.name
            },
            list() {
                return this.$route.matched.filter((route) => route.name || route.meta.label)
            }

        }
    }
</script>

<style scoped>
    .breadcrumb {
        margin-bottom: 0rem;
    }
</style>
